class SafetyIcons {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const iconWrapper = e.target.closest('.safety-icon-wrapper');
      const closeButton = e.target.closest('.safety-icon-tooltip__close');
      
      if (!iconWrapper && !closeButton) {
        this.closeAllTooltips();
        return;
      }
      
      if (closeButton) {
        e.stopPropagation();
        const tooltip = closeButton.closest('.safety-icon-wrapper');
        this.closeTooltip(tooltip);
        return;
      }
      
      if (iconWrapper) {
        e.preventDefault();
        e.stopPropagation();
        
        if (window.matchMedia('(hover: none)').matches) {
          this.closeAllTooltips();
          this.toggleTooltip(iconWrapper);
        }
      }
    });

    document.addEventListener('mouseleave', (e) => {
      const iconWrapper = e.target.closest('.safety-icon-wrapper');
      if (iconWrapper && window.matchMedia('(hover: hover)').matches) {
        setTimeout(() => {
          if (!iconWrapper.matches(':hover')) {
            this.closeTooltip(iconWrapper);
          }
        }, 100);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllTooltips();
      }
    });
  }

  toggleTooltip(iconWrapper) {
    const isActive = iconWrapper.classList.contains('tooltip-active');
    
    if (isActive) {
      this.closeTooltip(iconWrapper);
    } else {
      this.openTooltip(iconWrapper);
    }
  }

  openTooltip(iconWrapper) {
    iconWrapper.classList.add('tooltip-active');
  }

  closeTooltip(iconWrapper) {
    iconWrapper.classList.remove('tooltip-active');
  }

  closeAllTooltips() {
    const activeTooltips = document.querySelectorAll('.safety-icon-wrapper.tooltip-active');
    activeTooltips.forEach(tooltip => {
      this.closeTooltip(tooltip);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SafetyIcons();
  });
} else {
  new SafetyIcons();
} 